import { useIntl } from 'react-intl';
import { Box } from '@packages/shared/src/components/Box/Box';
import { Typography } from '@packages/shared/src/components/Typography/Typography';
import { usePathname } from 'next/navigation';
import { useSubscribeNewsletterGqlMutation } from '../helpers/useSubscribeNewsletterGqlMutation';
import { subscribeSheetMessages } from './helpers/messages';
import { generalFormMessages } from '../messages';

/**
 * Content for the DOI-Notification, consisting of an info text and a clickable text
 * that requests another Confirmation Email.
 */
export const DoiNotificationContent = ({
  onClickedSuccess,
  onClickedError,
  email,
}: {
  onClickedSuccess: () => void;
  onClickedError: (msg: string) => void;
  email: string;
}) => {
  const intl = useIntl();

  const pathname = usePathname();
  const { formatMessage } = useIntl();
  const doSubscribeNewsletterGql = useSubscribeNewsletterGqlMutation();

  const onSubmit = () =>
    doSubscribeNewsletterGql({
      formData: { email },
      areaKey: '',
      contextUri: pathname || '/',
    })
      .then(({ data: resultData, error: resultError }) => {
        if (resultError) {
          throw new Error(resultError.message);
        }
        if (
          resultData?.subscribeNewsletterRecipient &&
          'errors' in resultData.subscribeNewsletterRecipient &&
          resultData.subscribeNewsletterRecipient.errors &&
          resultData.subscribeNewsletterRecipient.errors.length > 0
        ) {
          throw new Error(formatMessage(generalFormMessages.errorApi));
        }
        onClickedSuccess();
      })
      .catch((error) => onClickedError(error.message));
  return (
    <Box>
      <Typography>{intl.formatMessage(subscribeSheetMessages.doiText, { email })}</Typography>
      <Box
        sx={{ cursor: 'pointer', textDecoration: 'underline', marginTop: 2 }}
        role="button"
        onClick={() => onSubmit()}
      >
        <Typography>{intl.formatMessage(subscribeSheetMessages.doiLink)}</Typography>
      </Box>
    </Box>
  );
};
